import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductHeaderTypeOneComponent } from './type-one/product-header-type-one.component';
import { AvatarPillComponent, VideoPlayersModule, UserAvatarPipe } from '@frontend/shared';
import { LoaderGlobeAnimationDetailComponent } from '../../loaders';
import { ProgressIndicatorCardSimpleModule } from '../../tracking/progress/progress-indicator-card-simple/progress-indicator-card-simple.module';
import { TranslocoModule } from '@jsverse/transloco';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TextListsModule } from '../../content/lists/text';
import { TooltipModule } from 'ngx-bootstrap/tooltip';



@NgModule({
  declarations: [ProductHeaderTypeOneComponent],
  exports: [ProductHeaderTypeOneComponent],
  imports: [
    CommonModule,
    FormsModule,
    VideoPlayersModule,
    LoaderGlobeAnimationDetailComponent,
    AvatarPillComponent,
    ProgressIndicatorCardSimpleModule,
    TranslocoModule,
    RatingModule,
    AlertModule,
    TextListsModule,
    TooltipModule,
    UserAvatarPipe,
  ]
})
export class ProductHeadersModule { }
